
import banner from '../../images/login-banner.png';
import styles from './index.module.css';

function AuthCard({ title, children }: { title: string; children: React.ReactNode }) {
    return (
        <div className={styles.page}>
            <div className={styles.brandBar}>
                <img src={banner} alt="Joyya" className={styles.brandLogo} />
            </div>
            <div className={styles.content}>
                <div className={styles.card}>
                    <h2 className={styles.cardTitle}>{title}</h2>
                    {children}
                </div>
            </div>
        </div>
    );
}

export { AuthCard };
